<template>
  <article>
    <section class="xbed-sub-title">
      <span>门店管理</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>基础数据管理</BreadcrumbItem>
        <BreadcrumbItem>门店管理</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="创建时间" :label-width="90">
          <DatePicker style="width:200px" type="daterange" v-model="dateRange" ref="datePicker"></DatePicker>
        </FormItem>
        <FormItem label="类型" :label-width="90">
          <Select style="width:160px" v-model="search.chainType">
            <Option value="S0">全部</Option>
            <Option value="0">分散</Option>
            <Option value="1">聚集</Option>
          </Select>
        </FormItem>
        <FormItem label="门店ID" :label-width="90">
          <Input v-model="search.chainId"></Input>
        </FormItem>
        <FormItem label="门店名称" :label-width="90">
          <Input v-model="search.chainName"></Input>
        </FormItem>
        <FormItem label="负责人" :label-width="90">
          <Input v-model="search.mainPerson" placeholder="姓名/手机号"></Input>
        </FormItem>
        <FormItem label="省份" :label-width="90">
          <Select style="width:160px" v-model="search.province" @on-change="(id)=>{this.changeProvice(id, true)}">
            <Option :value="-1">全部</Option>
            <Option v-for="item in provinceList" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="城市" :label-width="90">
          <Select style="width:160px" v-model="search.city">
            <Option :value="-1">全部</Option>
            <Option v-for="item in searchCitise" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="50" label="">
          <Button type="primary" @click="searchByPrama">查询</Button>
        </FormItem>
        <FormItem :label-width="20" label="">
          <Button type="primary" @click="addHotel">新增门店</Button>
        </FormItem>
      </Form>
      
      <Table :columns="columns" :data="chainList"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page :page-size="search.pageSize" show-total show-sizer :current="search.pageNum" :total="total" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
    </section>
    <div v-if="modal.display">
      <Modal v-model="modal.display" :title="modal.title" :loading="true" ref="hotelModal" @on-ok="okBtn">
      <Form :label-width="100" label-position="left" :model="hotel" :rules="rules" ref="hotelForm">
        <FormItem label="门店名称" prop="chainName">
          <Input v-model.trim="hotel.chainName" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="类型" prop="chainType">
          <Select v-model="hotel.chainType">
            <Option :value="0">分散</Option>
            <Option :value="1">聚集</Option>
          </Select>
        </FormItem>
        <FormItem label="省份" prop="province">
          <Select @on-change="changeProvice" v-model="hotel.province">
            <Option v-for="(item, index) in provinceList" v-if="item" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="市" prop="city">
          <Select @on-change="(id)=>{this.changeCitys(id || 0)}" v-model="hotel.city">
            <Option v-for="(item, index) in cityList" v-if="item" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="区" prop="district">
          <Select v-model="hotel.district">
            <Option v-for="(item, index) in areaList" v-if="item" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="中心仓数量">
          <Input disabled v-model="centerNum"></Input>
        </FormItem>
        <FormItem label="商圈" prop="tradingArea">
          <select v-model="hotel.tradingArea" style="width:386px;height:30px;color:rgb(73,80,96);padding-left:4px;border-radius: 4px;border:1px solid #ddd;">
            <option v-for="(item, index) in tagList" :key="index" :value="item.cname">{{item.cname}}</option>
          </select>
          <!-- <transition name="fade">
            <div class="ivu-form-item-error-tip">若该城市没有商圈，请先配置商圈</div>
          </transition> -->
        </FormItem>
        <FormItem label="街道地址" prop="address">
          <Input v-model="hotel.address" :maxlength="255"></Input>
          <transition name="fade">
            <div class="ivu-form-item-error-tip">提示：不需要填写省市区</div>
          </transition>
        </FormItem>
        <FormItem label="门店提醒">
          <Input v-model="hotel.remind" :maxlength="255"></Input>
        </FormItem>
        <FormItem label="是否xbed开票" prop="invoiceStatus">
          <RadioGroup v-model="hotel.invoiceStatus">
            <Radio :label="1">xbed开票</Radio>
            <Radio :label="0">不开票</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="开票主体" prop="invoiceConfigKey">
          <Select v-model="hotel.invoiceConfigKey">
            <Option v-for="(item, index) in invoiceList" v-if="item" :key="index" :value="item.dictName">{{item.dictValue}}</Option>
          </Select>
        </FormItem>

        <FormItem label="是否支持外籍人士入住" prop="foreignStatus">
          <RadioGroup v-model="hotel.foreignStatus">
            <Radio :label="0">不支持</Radio>
            <Radio :label="1">支持</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="是否只使用XMS/PMS" prop="isXpms">
          <RadioGroup v-model="hotel.isXpms">
            <Radio :label="0">否</Radio>
            <Radio :label="1">只使用XMS</Radio>
            <Radio :label="2">只使用PMS</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="合作模式" prop="isInn">
          <RadioGroup v-model="hotel.isInn">
            <Radio :label="0">非inn</Radio>
            <Radio :label="1">Xbed inn</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="派遣店长" prop="isDelegateManager">
          <RadioGroup v-model="hotel.isDelegateManager">
            <Radio :label="0">非派遣</Radio>
            <Radio :label="1">Xbed派遣</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="hotel.isDelegateManager == 0" label="门店负责人" prop="mainPerson">
          <Input v-model="hotel.mainPerson" :maxlength="50"></Input>
        </FormItem>
        <FormItem v-if="hotel.isDelegateManager == 0" label="负责人电话" prop="mainPhone">
          <Input v-model="hotel.mainPhone"></Input>
        </FormItem>
        <FormItem v-if="hotel.isDelegateManager == 0" label="门店电话" prop="contactPhone">
          <Input v-model="hotel.contactPhone" :maxlength="50"></Input>
        </FormItem>
        <!-- <FormItem v-if="hotel.isDelegateManager == 1">
          <transition name="fade">
            <span style="color: red">操作提示：OMS账号必须设置手机号才能选择为店长，多个店长不可重复选择账号</span>
          </transition>
        </FormItem> -->
        <span v-if="hotel.isDelegateManager == 1" style="color: red">操作提示：OMS账号必须设置手机号才能选择为店长，多个店长不可重复选择账号</span>
        <FormItem 
          :style="hotel.delegateManagers[0].showMessage ? 'marginBottom: 24px' : 'marginBottom: 5px'"
          v-if="hotel.isDelegateManager == 1" 
          label="主店长"
          :error="hotel.delegateManagers[0].error"
          :show-message="hotel.delegateManagers[0].showMessage"
        >
          <Select 
            :value="hotel.delegateManagers[0].query"  
            style="width: 90%; margin-right: 10%"
            placeholder="输入姓名或手机号"
            filterable
            clearable
            remote
            @on-query-change="(query)=>{inputChange(query,0)}"
            :remote-method="(query)=>{this.searchAccounts(query, 0)}"
            :loading="accountLoading"
            @on-change="(value)=>{this.onDelegateManagerChanged(value, 0)}"
          >
            <Option v-for="(item, index) in accountList[0]" v-if="item" :key="index" :value="item.query">{{item.userName + '_' + item.phone}}</Option>
          </Select>
        </FormItem>
        <a v-if="hotel.isDelegateManager == 1" style="margin: 0 0 10px 100px; display: inline-block;" @click="addKeeper"><Icon type="md-add-circle" style="font-size: 13px"></Icon> 添加副店长</a>

        <div v-if="hotel.isDelegateManager == 1">
          <div v-for="(item, i) in hotel.delegateManagers" :key="i">
            <FormItem 
              v-if="i > 0" 
              :label="`副店长 ` + i"
              :error="item.error"
              :show-message="item.showMessage"
            >
              <Select 
                v-model="item.query" 
                style="width: 90%"
                placeholder="输入姓名或手机号"
                filterable
                clearable
                remote
                :remote-method="(query)=> searchAccounts(query, i)"
                @on-query-change="(query)=>{inputChange(query,i)}"
                :loading="accountLoading"
                @on-change="(value)=> onDelegateManagerChanged(value, i)"
             >
                <Option v-for="(it, index) in accountList[i]" v-if="it" :key="index" :value="it.query">{{it.userName + '_' + it.phone}}</Option>
              </Select>
              <Icon type="md-close-circle" @click="()=>deleteKeeper(i)" style="font-size:20px; vertical-align: middle; margin-left: 10px" />
            </FormItem>
          </div>
        </div>
      </Form>
    </Modal>
    </div>
  
    <!-- qrcode-->
    <Modal v-model="qrcodeModal.display" ref="qrcodeModal" title="小程序码" :width="600" style="text-align:center;">
      <div style="height: 430px;">
        <img :src="qrcodeModal.rqcodeUrl"/>
      </div>  
      <div slot="footer">
        <Button @click="qrcodeModal.display = false">关闭</Button>
      </div>
    </Modal>
  </article>
</template>
  
<script>
import API from "../../api";
import Utils from "../../utils";
import Moment from 'moment';
import {contactPhoneRegExp, phoneRegular} from "../../utils/regular"
export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env);
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");

    this.apiHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
      'Authorization': Utils.findFromLocalStorage("Author-token"),//走阿里云需要
    }
  },
  mounted() {
    this.$Notice.config({
      top: 100
    });
    this.getProvince()
    this.getChainList()
    this.getInvoiceList()
  },
  data() {
    return {
      stop: false,
      validStatus: true,
      chainList: [],
      invoiceList: [],
      searchCitise: [],
      dateRange: ['',''],
      total: 0,
      search: {
        chainType: 'S0',
        chainId: '',
        chainName: '',
        province: -1,
        city: -1,
        mainPerson: '',
        pageNum: 1,
        pageSize: 10
      },
      modal: {
        display: false,
        isAdd: true,
        title: "新增门店"
      },
      columns: [
        {
          title: "门店ID",
          width: 85,
          align: 'center',
          key: 'chainId'
        },
        {
          title: "门店名称",
          width: 200,
          align: 'center',
          key: 'chainName'
        },
        {
          title: "类型",
          width: 200,
          align: 'center',
          key: 'chainType',
          render: (h, param) => {
            return h('span', param.row.chainType ? '聚集' : '分散')
          }
        },
        {
          title: "门店负责人",
          width: 200,
          align: 'center',
          key: 'mainPerson'
        },
        {
          title: "负责人电话",
          width: 200,
          align: 'center',
          key: 'mainPhone'
        },
        {
          title: "门店电话",
          width: 200,
          align: 'center',
          key: 'contactPhone'
        },
        {
          title: "中心仓数量",
          width: 200,
          align: 'center',
          key: 'storehouseNum'
        },
        {
          title: "省市区",
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span',{}, `${param.row.province} ${param.row.city} ${param.row.district}`)
          }
        },
        {
          title: "街道地址",
          width: 200,
          align: 'center',
          key: 'address'
        },
        {
          title: "所属商圈",
          width: 200,
          align: 'center',
          key: 'tradingArea'
        },
        {
          title: "门店提醒",
          width: 200,
          align: 'center',
          key: 'remind'
        },
        {
          title: "操作",
          width: 300,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.editHotel(param.row)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                style: {
                  marginLeft: '5px',
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '消息提醒',
                      content: `<p>确定删除${param.row.chainName}吗？</p><p>一经确定将无法修改</p>`,
                      onOk: () => {
                        this.delChain(param.row.chainId)
                      },
                    })
                  }
                }
              }, '删除'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: () => {
                    let params = {
                      chainName: param.row.chainName,
                      chainId: param.row.chainId,
                      province: param.row.province,
                      city: param.row.city,
                      district: param.row.district
                    }
                    Utils.removeItemFromLocalStorage('params')
                    Utils.saveToLocalStorage('params', JSON.stringify(params))
                    window.open(`#Order/Reserve/chainBuildingList`)
                  }
                }
              }, '查看楼宇'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    this.getMiniCode(param.row)
                  }
                }
              }, '小程序码'),
            ])
          }
        }
      ],
      provinceList: [],
      cityList: [],
      areaList: [],
      centerNum: 0,
      rules: {
        chainName: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        chainType: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '该项不能为空', trigger: 'blur' },
          { pattern: contactPhoneRegExp, message: '格式不正确', trigger: 'change' }
        ],
        province: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        city: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        district: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        // tradingArea: [
        //   { required: true, message: ' ', trigger: 'blur' }
        // ],
        mainPerson: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        mainPhone: [
          { required: true, message: '该项不能为空', trigger: 'blur' },
          { pattern: phoneRegular, message: '格式不正确', trigger: 'change' }
        ],
        invoiceConfigKey: [
          { required: true, message: '发票主体名称不能为空', trigger: 'blur' }
        ],
        invoiceTaxpayerId: [
          { required: true, message: '发票主体税号不能为空', trigger: 'blur' }
        ],
      },
      hotel: {},
      tagList:[],
      qrcodeModal: {
        display: false,
        rqcodeUrl: null,
      },
      accountList: [],
      accountLoading: false,
      isDelete: false
    };
  },
  methods: {
    searchByPrama() {
      this.search.pageNum = 1
      this.search.pageSize = 10
      this.getChainList()
    },
    changePage(page) {
      this.search.pageNum = page
      this.getChainList()
    },
    changePageSize(size) {
      this.search.pageNum = 1
      this.search.pageSize = size
      this.getChainList()
    },
    addHotel() {
      this.accountList = []
      this.modal.isAdd = true
      this.modal.display = true
      this.modal.title = "新增门店"
      this.hotel = {
        chainName: "",
        chainType: 0,
        contactName: "",
        contactPhone: "",
        remind: "",
        province: 1,
        city: 52791,
        district: 72,
        address: "",
        tradingArea: "",
        foreignStatus: 0,
        isXpms: 0,
        isInn:0,
        mainPerson: "",
        mainPhone: "",
        invoiceStatus: 1,
        invoiceConfigKey: 'network',
        isDelegateManager: 0, //是否派遣店长 0 -no 1 - yes
        delegateManagers: [{isMainManager: 1}] //店长列表
      }
      this.changeProvice(this.hotel.province)
    },
    async editHotel(obj) {
      this.accountList = []
      this.stop = true
      this.centerNum = obj.storehouseNum
      this.hotel = {
        chainId: obj.chainId,
        chainName: obj.chainName,
        chainType: obj.chainType,
        contactName: obj.contactName,
        contactPhone: obj.contactPhone,
        remind: obj.remind,
        province: '',
        city: '',
        district: '',
        address: obj.address,
        tradingArea: obj.tradingArea,
        foreignStatus: obj.foreignStatus,
        isXpms:obj.isXpms||0,
        isInn:obj.isInn||0,
        mainPerson: obj.mainPerson,
        mainPhone: obj.mainPhone,
        invoiceStatus: obj.invoiceStatus,
        invoiceTaxpayerId: obj.invoiceTaxpayerId,
        invoiceConfigKey: obj.invoiceConfigKey,
        isDelegateManager: obj.isDelegateManager, //是否派遣店长 0 -no 1 - yes
        delegateManagers: obj.delegateManagers || [] //店长列表
      }
      if (obj.delegateManagers) {
        let managers = JSON.parse(obj.delegateManagers)
        //获取主店长，及店长列表，生成query
        let i = 0, mainIndex = -1
        let list = []
        while( i < managers.length) {
          let item = managers[i];
          if (item.isMainManager === 1) {
            mainIndex = i
          }
          list.push({
            ...item,
            query: `${item.userName}_${item.phone}`
          })
          this.accountList.push([])
          i++;
        }

        if (mainIndex != -1) {
          let mainItem = list[mainIndex];
          list.splice(mainIndex, 1)
          list.splice(0, 0, mainItem)
        }
        this.hotel.delegateManagers = list
      }
      else {
        this.hotel.delegateManagers = [{isMainManager: 1}]
      }

      this.modal.isAdd = false
      this.modal.display = true
      this.modal.title = "编辑门店"
      this.hotel.province = this.getIdByName(obj.province, this.provinceList)[0].id || ""
      this.cityList = (await API.omsAPI[this.env].php.cityList({"id": this.hotel.province})).data
      this.hotel.city = this.getIdByName(obj.city, this.cityList)[0].id || ""
      this.areaList =(await API.omsAPI[this.env].php.countyslist({"id": this.hotel.city})).data
      this.hotel.district = this.getIdByName(obj.district, this.areaList)[0].id || ""
      this.tagChildList(obj.city)

      !this.hotel.invoiceStatus && (this.hotel.invoiceStatus = 0)
      !this.hotel.tradingArea && (this.hotel.tradingArea = '')
      this.modal.isAdd = false
      this.modal.display = true
      this.modal.title = "编辑门店"
      this.stop = false
    },
    async getProvince() {
      let resp = (await API.omsAPI[this.env].php.provincesList()).data;
      this.provinceList = resp
    },
    // async getCity(proviceId, isSearch) {
    //   let resp =  (await API.omsAPI[this.env].php.cityList({"id": proviceId})).data;
    //   if(isSearch) {
    //     this.searchCitise = resp
    //     return
    //   }
    //   this.cityList = resp
    // },
    async getArea(cityId) {
      let resp =  (await API.omsAPI[this.env].php.countyslist({"id": cityId})).data;
      this.areaList = resp
      !this.hotel.district && (this.hotel.district = this.areaList[0].id)
    },
    async changeProvice(proviceId, isSearch) {
      if(this.stop) return
      if(proviceId === -1) return
      this.cityList = []
      let resp = (await API.omsAPI[this.env].php.cityList({"id": proviceId})).data;
      if(isSearch) {
        this.searchCitise = resp;
        this.search.city = -1
      }else{
        this.cityList = resp
        this.hotel.city = resp[0].id
        this.changeCitys(this.hotel.city)
        this.tagChildList(this.getNameById(this.hotel.city, this.cityList)[0].name)
        this.centerManagementHouseNum(this.getNameById(this.hotel.city, this.cityList)[0].name)
      }
    },
    async changeCitys(cityId){
      if(this.stop) return
      if(this.getNameById(cityId, this.cityList)[0]){
        this.tagChildList(this.getNameById(cityId, this.cityList)[0].name)
        this.centerManagementHouseNum(this.getNameById(cityId, this.cityList)[0].name)
      }
      let resp =  (await API.omsAPI[this.env].php.countyslist({"id": cityId})).data;
      this.areaList = resp
      if(resp[0]&&resp[0].id){
        this.hotel.district = resp[0].id
      }
      this.hotel.tradingArea = ''
    },
    async getChainList() {
      let jsonObj = {
        url: '/roomChain/searchChain',
        province: this.search.province == '-1' ? '' : this.getNameById(this.search.province, this.provinceList)[0].name,
        city: this.search.city == '-1' ? '' : this.getNameById(this.search.city, this.searchCitise)[0].name,
        pageNum: this.search.pageNum || 1,
        pageSize: this.search.pageSize || 10,
        chainName: this.search.chainName,
        chainId: this.search.chainId,
        beginDate: this.dateRange[0] ? Moment(this.dateRange[0]).format('YYYY-MM-DD') : '',
        endDate: this.dateRange[1] ? Moment(this.dateRange[1]).format('YYYY-MM-DD') : '',
        chainType: this.search.chainType == 'S0' ? '' : this.search.chainType,
        mainPerson: this.search.mainPerson,
      }
      let resp = (await API.omsAPI[this.env].room.roomSystem(
        jsonObj,
        'get',
        this.token,
      )).data
      if(!resp.retCode){
        this.chainList = resp.list;
        this.total = resp.total
      }
    },
    async getInvoiceList(){
      // 查询发票主体的字典列表
      let params = {
        pageNum: 1,
        pageSize: 10,
        groupId: 47
      }
      const resp = (await API.omsAPI[this.env].clientServer.dictValueList(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      this.invoiceList = resp.list
    },
    filterInvoice(invoiceConfigKey){
      return this.invoiceList.filter((item) => { return item.dictName == invoiceConfigKey })
    },
    okBtn() {
      if((this.hotel.chainType === 0 && this.hotel.isXpms === 1) || (this.hotel.chainType === 0 && this.hotel.isXpms === 2)){
        this.$Notice.error({
          title: "操作失败",
          desc: '分散型门店不可使用XMS/PMS，请重新设置'
        });
        return this.$refs['hotelModal'].buttonLoading = false;
      }

      if (this.hotel.isDelegateManager === 1) {
        if (!this.hotel.delegateManagers[0].query) {
          this.$Notice.error({
            title: "操作失败",
            desc: '主店长不能为空'
          });
          return this.$refs['hotelModal'].buttonLoading = false;
        }

        let errList = this.hotel.delegateManagers.filter(item => item.showMessage)
        if (errList.length > 0) {
          this.$Notice.error({
            title: "操作失败",
            desc: '副店长不可重复选择相同账号'
          });
          return this.$refs['hotelModal'].buttonLoading = false;
        }
      }

      this.$refs['hotelForm'].validate(valid => {
        if(valid) {
          this.addChain()
        }else{
          this.$refs['hotelModal'].buttonLoading = false
        }
      })
    },
    async addChain(){
      let jsonObj = Object.assign({}, this.hotel);
      jsonObj.chainName = (jsonObj.chainName).replace(/\+/g, "%2B").replace(/\&/g, '%26')
      jsonObj.province = this.getNameById(this.hotel.province, this.provinceList)[0].name
      jsonObj.city = this.getNameById(this.hotel.city, this.cityList)[0].name
      jsonObj.district = this.getNameById(this.hotel.district, this.areaList)[0].name
      console.log(jsonObj, "jsonObj")

      if (jsonObj.isDelegateManager === 1) {
        delete jsonObj.mainPerson
        delete jsonObj.mainPhone
        delete jsonObj.contactPhone
        let list = jsonObj.delegateManagers.filter(item => {
          delete item.query
          delete item.error
          delete item.showMessage

          return item.userId != null;
        });

        jsonObj.provinceId = this.hotel.province
        jsonObj.cityId = this.hotel.city
        jsonObj.delegateManagers = JSON.stringify(list)
      } else {
        delete jsonObj.delegateManagers
      }

      let resp;
      if(this.modal.isAdd) {
        jsonObj.createName = this.username;
        resp = (await API.omsAPI[this.env].php.addChain(jsonObj)).data
      }else{
        jsonObj.updateName = this.username;
        resp = (await API.omsAPI[this.env].php.editChain(jsonObj)).data
      }
      if(resp.retcode == 1) {
        this.$Notice.success({
          title: '操作成功'
        })
        this.modal.display = false
        this.getChainList()
      }else{
        this.$Notice.error({
          title: '操作失败',
          desc: resp.retmsg
        })
        this.$refs['hotelModal'].buttonLoading = false
      }
    },
    async delChain(chainId) {
      let resp = (await API.omsAPI[this.env].php.delChain({chainId})).data
      if(resp.retcode == 1){
        this.$Notice.success({
          title: '操作成功',
        })
        this.getChainList()
      }else{
        this.$Notice.error({
          title: '操作失败',
          desc: resp.retmsg
        })
      }
    },

    /**
     * 获取城市下的商圈
     */
    async tagChildList(cityName) {
      let resp = (await API.omsAPI[this.env].php.tagChildList({
        cnameWay: `商圈/${cityName}`
      })).data
      if(resp.retcode == 1) {
        this.tagList = resp.retdata
      }else{
        this.tagList = []
      }
    },
    /**
     * 获取城市中心仓
     */
    async centerManagementHouseNum(cityId) {
      let resp = (await API.omsAPI[this.env].cleaner.centerManagementHouseNum(
        { citys: cityId },
        this.token
      )).data
      if(!resp.retCode) {
        this.centerNum = resp.content[0].number
      }else{
        this.centerNum = 0
      }
    },
    getNameById(id, list){
      return list.filter(item => {
        return item.id === id
      })
    },
    getIdByName(name, list) {
      return list.filter(item => {
        return item.name == name
      })
    },

    // 获取小程序码
    async getMiniCode (row) {
      this.qrcodeModal.rqcodeUrl = null
      this.qrcodeModal.display = true
      let params = {
        scene: row.chainId,
        page: 'pages/subpackages/hotel/chain-detail/main',
        isBase64: 0
      }
      const resp = (await API.omsAPI[this.env].clientServer.getMiniCode(params, {'x-ca-stage':this.headerENV,'token':this.token})).data
      this.qrcodeModal.rqcodeUrl = resp
    },
    
    /**
    * 添加副店长记录
    * isMainManager 0副店长 1主店长
    */
    addKeeper() {
      if (this.accountList.length >= 11) {
        this.$Notice.warning({title: '最多增加10个副店长'})
        return
      }
      this.hotel.delegateManagers.push({isMainManager: 0})
      this.accountList.push([])
    },

    /**
    * 删除副店长记录
    */
    deleteKeeper(index) {
      this.isDelete = true;
      this.accountList.splice(index, 1)
      // this.hotel.delegateManagers.splice(index, 1)
      // this.hotel.delegateManagers = [...this.hotel.delegateManagers];
      // this.accountList = []

      let list = this.updateManagerMessage(index)

      //重新触发渲染
      //如果不触发控件显示有问题
      this.hotel.isDelegateManager = 0
      setTimeout(() => {
        this.hotel.isDelegateManager = 1
        this.hotel.delegateManagers = list
      }, 50)
    },

    /**
     * 店长选择变化
     */
    onDelegateManagerChanged(value, index) {

      let error = '', showMessage = false;
      for (let i = 0; i < this.hotel.delegateManagers.length; i++) {
        const item = this.hotel.delegateManagers[i];
        if ((item.query == value || value.indexOf(item.query) > -1) && i != index) {
          error = '店长不可重复选择相同账号，请重新选择';
          showMessage = true;
          break
        }
      }

      let oldItem = this.hotel.delegateManagers[index];
      let newItem = value.split('_')
      this.hotel.delegateManagers[index] = {
        ...oldItem,
        userId: newItem[0]*1,
        userName: newItem[1],
        phone: newItem[2],
        query: value,
        error,
        showMessage
      }
    },

    /**
     * 搜索店长列表
     */
    async searchAccounts(query, index) {
      if (this.isDelete) {
        this.isDelete = false;
        return
      }
      if (query !== '') {
          this.accountLoading = true;
          try {
            let resp = (await API.omsAPI[this.env].clientServer.queryUserListByKeyword(query, this.apiHeaders)).data
            let list = resp.filter(item => {
              item.query = `${item.userId}_${item.userName}_${item.phone}`
              return true
            })

            this.accountList[index] = list || [];
            this.accountLoading = false;
          } catch (error) {
            this.accountLoading = false;
          }

      } else {
          this.accountList[index] = [];
          this.delegateManagers[index] = {
            isMainManager: index == 0 ? 1 : 0
          }
      }
    },

    inputChange(query, index) {
      if (!query || query == '') {
        this.accountList[index] = [];
        this.hotel.delegateManagers[index] = {
          isMainManager: index == 0 ? 1 : 0
        }

        //重新触发渲染
        //如果不触发控件显示有问题
        this.hotel.isDelegateManager = 0
        setTimeout(() => {
          this.hotel.isDelegateManager = 1
          this.hotel.delegateManagers = this.updateManagerMessage()
        }, 50)
      }
    },

    updateManagerMessage(index = -1) {
      let hash = {}

      let list = this.hotel.delegateManagers.filter((item, i) => {
        item.query = item.userName ? `${item.userName}_${item.phone}` : null;
        // i != index && this.accountList.push([])
        if (item.query && !hash[item.query] && i != index) {
          item.error = '';
          item.showMessage = false;
          hash[item.query] = item;
        }
        return index > -1 ? i != index : true;
      })

      return list;
    }
    /**
     * XMS/PMS 选项 与 类型（聚集）联动 检测
     * return true 不通过 检测
     */
    // isUnUnion(){
    //   return this.hotel.isXpms && (this.hotel.isXpms ^ this.hotel.chainType)
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/basic-data-management/hotel-list.vue